import React from 'react';

import SalesMeeting from '../../components/Prospecting/SalesMeeting';

function SalesMeetingView() {
  return (
    <SalesMeeting />
  );
}

export default SalesMeetingView; 